export const DASHBOARD_URL = "dashboard";

export const DASHBOARD_ACTIVITIES_URL = `${DASHBOARD_URL}/activities`;
export const DASHBOARD_CHART_URL = `${DASHBOARD_URL}/chart`;

export const DASHBOARD_FILTER_DATE = [
  {
    label: "txt_today",
    value: "1d",
  },
  {
    label: "txt_one_month",
    value: "1m",
  },
  {
    label: "txt_one_year",
    value: "1y",
  },
];
